<!-- Loaded states -->
@if ((stateHasLoaded$ | async)) {
  @if (userLoaded$ | async; as userLoaded) {
    @if (userLoaded) {
      <app-top-bar></app-top-bar>
    }
  }
  <!-- todo: move into app-map component -->
  @if (userLoaded$ | async; as userLoaded) {
    @if (userLoaded) {
      <app-context-menu></app-context-menu>
    }
  }
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  @if (!isIframe) {
    <router-outlet></router-outlet>
  }
} @else {
  <div id="bootscreen" class="d-flex align-items-center justify-content-center"
    style="z-index: 10000; background: #f5f5f5; position: absolute; left: 0; right: 0; top: 0; bottom: 0;">
    <div style="position: relative;">
      <div class="dust-cloud">
        <div class="dust-ball"></div>
        <div class="dust-ball"></div>
        <div class="dust-ball"></div>
        <div class="dust-ball"></div>
      </div>
      <div class="dust-cloud right">
        <div class="dust-ball"></div>
        <div class="dust-ball"></div>
        <div class="dust-ball"></div>
        <div class="dust-ball"></div>
      </div>
      <img class="car-animation" width="150px" src="assets/img/oms-logo.png" />
    </div>
  </div>
}
